// @ts-check
/**
 * @typedef ImageDisplayOptions
 * @property {string} alt_text
 * @property {import('react').CSSProperties['objectFit']} [fit]
 * @property {import('react').CSSProperties['objectPosition']} [position]
 * @property {string} url
 */

/**
 * @function
 * @param {import('../CSTypes').BynderImageOptions} [opt=null]
 * @param {number} [quality=85]
 * @returns {ImageDisplayOptions}
 */
export function getImageDisplayOptions(opt = null, quality = 85) {
	const ret = {
		alt_text: opt?.alt_text,
		url: ConstructTransformsUrl(opt, quality),
		fit: opt?.background_size === 'auto' ? undefined : opt?.background_size,
	};

	if (opt?.x_position && opt?.y_position) {
		ret.position = opt.x_position + ' ' + opt.y_position;
	}

	return ret;
}

/**
 * Construct the full url based on the Image Options.
 * @param {import('../CSTypes').BynderImageOptions} opt
 * @param {number} [quality=85] The percentage of quality. @default 85
 * @return {string} The Full URL.
 */
export function ConstructTransformsUrl(opt, quality = 85) {
	const imgUrl = opt?.image?.files?.transformBaseUrl?.url;
	if (!imgUrl) {
		return '';
	}

	const transforms = (opt.transforms ?? []).reduce((ret, cur) => ret + getTransformString(cur), '');

	// FIXME: We are swapping to jpeg to support super old browsers without webp support - ew.
	// There is a PR out to support WebP. Be sure that this is fixed here.
	return imgUrl + '?' + transforms + 'format=jpg&quality=' + quality;
}

/**
 * @function
 * @param {import('../CSTypes').ImageTransforms} cur
 * @returns string
 */
export function getTransformString(cur) {
	if (!cur || Object.entries(cur).length === 0) {
		return null;
	}

	const ret = ['io='];
	// Bynder supports 'transform:fit' as well as 'overlay:box'. Default to transform if missing.
	// NOTE: this is regression-safe when updating the dropdown lists to return 'transform:fit' instead of just 'fit'.
	if (cur.transform?.includes(':')) {
		ret.push(cur.transform);
	} else {
		ret.push('transform:', cur.transform);
	}

	ret.push(transformOptionsToString(cur.transform_options), '&');

	return ret.join('');
}

/**
 *
 * @param {import('../CSTypes').CSImageTransformOption[]} opts
 * @returns {string}
 */
function transformOptionsToString(opts) {
	return opts.reduce((prev, { key, value }) => [prev, ',', key, ':', value].join(''), '');
}
